import React from 'react';
const PatientTagMore = (props) => {
    return (
      <button
        className="btn border rounded ml-3"
        type="button"
        style={{
          backgroundColor: "#17bae0",
          color: "#fff",
        }}
      >
        {props.number} More
      </button>
    );
  };
  
  export default PatientTagMore